var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.mergeProps.tag,{tag:"component",class:['title', `typo--${_vm.mergeProps.size}`],domProps:{"innerHTML":_vm._s(_vm.mergeProps.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }